<template lang="pug">
  .card.lesson-card
    //- .card-image(v-if="lesson.presentations.count()")
      img(:src="lesson.presentations.first().thumbnail")
    .card-content
      .media
        .media-content
          p.title.is-4
            b-icon(icon="book-open-variant")
            |  {{ lesson.name }}
          p.subtitle.is-6(v-if="lesson.category")
            span.has-text-grey Категория:
            span  {{ lesson.category.name }}

      .content(v-if="lesson.description") {{ lesson.description }}
    .card-footer
      .card-footer-item.has-text-success(v-if="lesson.finished")
        b-icon(icon="check-circle")
        span Изучен
      .card-footer-item(v-else)
        | Не изучен
      b-tooltip.card-footer-item(position="is-bottom" label="Прогресс")
        //- @todo вынести в отдельный компонент ui-progress-icon
        b-icon(:icon="progressIcon")
        span {{ lesson.progress }}
      router-link.card-footer-item(:to="{name: 'site.lessons.read', params: {id: lesson.id}}")
        | Читать
        b-icon(icon="arrow-right-circle")
</template>

<script>
import Lesson from '@/models/Lesson';

export default {
  name: 'lesson-card',

  props: {
    lesson: {
      type: Lesson,
    },
  },

  computed: {
    progressIcon() {
      let progress = parseInt(this.lesson.progress);
      let index = Math.round((progress / 100) * 8);
      return index ? `circle-slice-${index}` : 'circle-outline';
    },
  },
};
</script>
